__turbopack_context__.v({
  "bold": "LeadFormNew-module-scss-module__wL0BGG__bold",
  "card": "LeadFormNew-module-scss-module__wL0BGG__card",
  "cards": "LeadFormNew-module-scss-module__wL0BGG__cards",
  "container": "LeadFormNew-module-scss-module__wL0BGG__container",
  "divider": "LeadFormNew-module-scss-module__wL0BGG__divider",
  "filled": "LeadFormNew-module-scss-module__wL0BGG__filled",
  "formSection": "LeadFormNew-module-scss-module__wL0BGG__formSection",
  "half": "LeadFormNew-module-scss-module__wL0BGG__half",
  "heading": "LeadFormNew-module-scss-module__wL0BGG__heading",
  "paragraph": "LeadFormNew-module-scss-module__wL0BGG__paragraph",
  "proceedToApply": "LeadFormNew-module-scss-module__wL0BGG__proceedToApply",
  "programHeading": "LeadFormNew-module-scss-module__wL0BGG__programHeading",
  "programListPageHeading": "LeadFormNew-module-scss-module__wL0BGG__programListPageHeading",
  "root": "LeadFormNew-module-scss-module__wL0BGG__root",
  "seatBar": "LeadFormNew-module-scss-module__wL0BGG__seatBar",
  "seatContainer": "LeadFormNew-module-scss-module__wL0BGG__seatContainer",
  "stars": "LeadFormNew-module-scss-module__wL0BGG__stars",
  "thankYou": "LeadFormNew-module-scss-module__wL0BGG__thankYou",
});
